import { useContext } from 'react';
import { SearchResultsContext } from '../Context';

export default function useSearchResultsFolders() {
  const [state] = useContext(SearchResultsContext);
  return state.folders;
}

export { useSearchResultsFolders };